/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
// OfertaRow.tsx
import React from 'react';
import { OfertaRegistroAPI } from 'types/models/OfertasServiceNuevoOnboarding';
import I18n from 'i18n-js';
import cx from 'classnames';
import styles from './OfertaForm.module.scss';

interface Props {
  data: Partial<OfertaRegistroAPI>;
  onChange: (data: Partial<OfertaRegistroAPI>) => void;
  readOnly?: boolean;
  campos: { key: keyof OfertaRegistroAPI; label: string }[];
  onDelete?: () => void;
  onView?: () => void;
}

const OfertaRow = ({ data, onChange, readOnly = false, campos, onDelete, onView }: Props) => {
  const handleChange = (key: keyof OfertaRegistroAPI, value: number) => {
    onChange({ ...data, [key]: value });
  };
  const modosDeAcceso = {
    0: I18n.t('Oferta.modo.ahorroSiempre'),
    1: I18n.t('Oferta.modo.derechoExclusivo'),
    2: I18n.t('Oferta.modo.vendaEnergia'),
  };
  const excedentes = {
    0: I18n.t('ComunidadesDetallePage.detailData.labels.noExcedentes'),
    1: I18n.t('ComunidadesDetallePage.detailData.labels.conExcedentes'),
    2: I18n.t('ComunidadesDetallePage.detailData.labels.sinCompensacion'),
  };

  // const modosPedirIban = {
  //   0: 'Si',
  //   1: 'No',
  // };
  const normalizeBool = (v: unknown): boolean | undefined => {
    if (v === undefined || v === null || v === '') return undefined;
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return v === 1; // por si te llega 0/1 histórico
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      if (s === '1' || s === 'true' || s === 'sí' || s === 'si' || s === 'yes') return true;
      if (s === '0' || s === 'false' || s === 'no') return false;
    }
    return undefined;
  };
  const renderInput = (campo: { key: keyof OfertaRegistroAPI; label: string }) => {
    const value = data[campo.key];

    if (campo.key === 'origen_de_datos') {
      return (
        <input
          type="text"
          step="any"
          style={{ textAlign: 'center' }}
          disabled
          value={typeof value === 'boolean' ? '' : value ?? ''}
          onChange={(e) => handleChange(campo.key, parseFloat(e.target.value) || 0)}
        />
      );
    }
    if (campo.key === 'modo_de_acceso') {
      return (
        <select
          disabled={readOnly}
          className={styles.input}
          value={typeof value === 'boolean' ? '' : value ?? ''}
          onChange={(e) => handleChange(campo.key, parseInt(e.target.value, 10))}
        >
          <option value="">--</option>
          {Object.entries(modosDeAcceso).map(([val, label]) => (
            <option key={val} value={val}>
              {label}
            </option>
          ))}
        </select>
      );
    }

    if (campo.key === 'excedentes') {
      return (
        <select
          disabled={readOnly}
          className={styles.input}
          value={typeof value === 'boolean' ? '' : typeof value === 'number' ? value : parseInt(value ?? '', 10) ?? ''}
          onChange={(e) => handleChange(campo.key, parseInt(e.target.value, 10))}
        >
          <option value="">--</option>
          {Object.entries(excedentes).map(([val, label]) => (
            <option key={val} value={val}>
              {label}
            </option>
          ))}
        </select>
      );
    }

    if (campo.key === 'pedir_iban') {
      const boolVal = normalizeBool(data[campo.key]);
      const selectValue: '' | 'true' | 'false' = boolVal === undefined ? '' : boolVal ? 'true' : 'false';

      return (
        <select
          disabled={readOnly}
          className={styles.input}
          value={selectValue}
          onChange={(e) =>
            onChange({
              ...data,
              [campo.key]: e.target.value === '' ? undefined : e.target.value === 'true',
            })
          }
        >
          <option value="">--</option>
          <option value="true">Sí</option>
          <option value="false">No</option>
        </select>
      );
    }

    if (campo.key === 'precio_de_acceso') {
      const modo = Number(data.modo_de_acceso); // normaliza por si viene como string
      const enabled = modo === 1;

      return (
        <input
          type="number"
          step="any"
          disabled={readOnly || !enabled}
          className={styles.input}
          value={
            typeof value === 'boolean' ? '' : value ?? '' // NO fuerces a '0' aquí
          }
          onChange={(e) => handleChange(campo.key, e.target.value === '' ? 0 : parseFloat(e.target.value))}
          placeholder={enabled ? '0' : ''}
        />
      );
    }

    if (campo.key === 'percentaje_facturacion') {
      return (
        <input
          type="number"
          step="any"
          disabled={readOnly || data.modo_de_acceso !== 0}
          className={styles.input}
          value={typeof value === 'boolean' ? '' : value ?? ''}
          onChange={(e) => handleChange(campo.key, parseFloat(e.target.value) || 0)}
        />
      );
    }

    return (
      <input
        type="number"
        step="any"
        disabled={readOnly}
        className={styles.input}
        value={typeof value === 'boolean' ? '' : value ?? ''}
        onChange={(e) => handleChange(campo.key, parseFloat(e.target.value) || 0)}
      />
    );
  };

  return (
    <tr className={cx(styles.t_row)}>
      {campos.map((campo) => (
        <td key={campo.key} className={styles.t_content}>
          {renderInput(campo)}
        </td>
      ))}

      <td className={styles.t_content}>
        <button
          type="button"
          className={cx(styles.iconButton, styles.viewButton)}
          onClick={() => onView?.()}
          aria-label={I18n.t('Oferta.ver_detalle') || 'Ver detalle'}
          title={I18n.t('Oferta.ver_detalle') || 'Ver detalle'}
        >
          <span aria-hidden>👁️</span>
        </button>
        {!readOnly && (
          <button type="button" onClick={onDelete} className={styles.deleteButton}>
            ❌
          </button>
        )}
      </td>
    </tr>
  );
};

export default OfertaRow;
